(() => {
  const menu = document.querySelector('#site-menu');
  const content = document.querySelector('#menu-shop');
  if (!menu || !content) return;

  const panels = [...content.querySelectorAll('[data-shop-panel]')];
  const buttons = [...menu.querySelectorAll('[data-shop-modal-open]')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const closeButton = menu.querySelector('.menu-close');
  let trigger = null;
  let timer = 0;
  let activationFrame = 0;
  let open = false;
  let previousClose = null;
  const headerMotion = [];
  const illustrations = new Map();
  if (window.lottie) {
    content.querySelectorAll('[data-shop-art]').forEach(host => {
      const kind = host.dataset.shopArt;
      if (!(window.Fermenta && window.Fermenta.lottie || {})[`shop-${kind}-reveal`]) return;
      const animation = window.lottie.loadAnimation({container: host, renderer: 'svg', loop: false, autoplay: false, path: (window.Fermenta && window.Fermenta.lottie || {})[`shop-${kind}-reveal`]});
      const item = {animation, ready: false};
      illustrations.set(kind, item);
      animation.addEventListener('DOMLoaded', () => {
        item.ready = true;
        host.classList.add('is-loaded');
        if (open && !host.closest('[data-shop-panel]').hidden && !reducedMotion.matches) animation.goToAndPlay(0, true);
        else animation.goToAndStop(animation.totalFrames - 1, true);
      });
    });
  }
  const settleIllustrations = () => illustrations.forEach(({animation, ready}) => {
    if (ready) animation.goToAndStop(animation.totalFrames - 1, true);
  });
  const revealIllustration = kind => {
    settleIllustrations();
    const item = illustrations.get(kind);
    if (item?.ready && !reducedMotion.matches) item.animation.goToAndPlay(0, true);
  };
  reducedMotion.addEventListener('change', () => { if (reducedMotion.matches) settleIllustrations(); });
  const headerRects = () => [...menu.querySelectorAll('.menu-brand, .menu-utils')].map(element => ({ element, rect: element.getBoundingClientRect() }));
  const flowHeader = (before, opening) => {
    headerMotion.splice(0).forEach(animation => animation.cancel());
    if (reducedMotion.matches || !window.matchMedia('(max-width: 720px)').matches) return;
    before.forEach(({ element, rect }) => {
      const next = element.getBoundingClientRect();
      const x = rect.left - next.left;
      const y = rect.top - next.top;
      if (Math.abs(x) + Math.abs(y) < 2) return;
      headerMotion.push(element.animate([
        { translate: `${x}px ${y}px` },
        { translate: '0px 0px' },
      ], { duration: opening ? 620 : 460, easing: opening ? 'cubic-bezier(.2,.9,.22,1)' : 'cubic-bezier(.32,.72,0,1)' }));
    });
  };

  const resize = () => {
    if (!open) return;
    const mobile = window.matchMedia('(max-width: 720px)').matches;
    // The cached collapsed-menu width can belong to the previous breakpoint.
    // Measure the desktop link row, not the shell that is currently animating.
    const links = menu.querySelector('.menu-links');
    menu.classList.toggle('is-pinned', !mobile);
    const desktopWidth = Math.ceil((links?.offsetWidth || 588) + 12);
    // MENU は右端をページ余白に揃えているので、開いたパネルも左右に同じ余白を残す
    const gutter = document.documentElement.clientWidth - menu.getBoundingClientRect().right;
    const width = mobile
      ? Math.min(380, document.documentElement.clientWidth - gutter * 2)
      : Math.min(desktopWidth, 720, document.documentElement.clientWidth * .92);
    menu.style.setProperty('--shop-open-w', `${width}px`);
    if (!mobile) {
      menu.style.setProperty('--menu-open', `${Math.max(240, desktopWidth - 44)}px`);
      menu.style.setProperty('--menu-open-pinned', `${desktopWidth}px`);
    }
    content.style.width = `${width - 12}px`;
    const available = window.innerHeight - menu.getBoundingClientRect().top - 16;
    const height = Math.min(56 + content.scrollHeight + 6, available);
    content.style.width = '';
    menu.style.setProperty('--shop-open-h', `${Math.ceil(height)}px`);
  };

  const close = (restoreFocus = true) => {
    if (!open) return;
    open = false;
    settleIllustrations();
    const before = headerRects();
    window.clearTimeout(timer);
    cancelAnimationFrame(activationFrame);
    content.classList.remove('is-active');
    menu.classList.add('is-shop-closing');
    menu.classList.remove('is-shop-open');
    flowHeader(before, false);
    buttons.forEach(button => button.setAttribute('aria-expanded', 'false'));
    closeButton.setAttribute('aria-label', 'メニューを閉じる');
    if (previousClose) {
      closeButton.hidden = previousClose.hidden;
      closeButton.tabIndex = previousClose.tabIndex;
      closeButton.setAttribute('aria-hidden', previousClose.ariaHidden);
    }
    timer = window.setTimeout(() => {
      content.hidden = true;
      menu.classList.remove('is-shop-closing');
      menu.dispatchEvent(new CustomEvent('fermenta:shop-closed'));
      if (restoreFocus) trigger?.focus({ preventScroll: true });
    }, reducedMotion.matches ? 0 : 520);
  };

  buttons.forEach(button => {
    button.setAttribute('aria-controls', 'menu-shop');
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', () => {
      if (open && trigger === button) { close(); return; }
      window.clearTimeout(timer);
      cancelAnimationFrame(activationFrame);
      const before = headerRects();
      const opening = !open;
      trigger = button;
      const kind = button.dataset.shopModalOpen;
      panels.forEach(panel => { panel.hidden = panel.dataset.shopPanel !== kind; });
      content.setAttribute('aria-labelledby', kind === 'cart' ? 'shop-modal-cart-title' : 'shop-modal-account-title');
      content.querySelector('[data-shop-label]').textContent = kind === 'cart' ? 'カート' : 'アカウント';
      buttons.forEach(item => item.setAttribute('aria-expanded', String(item === button)));
      if (!open) {
        previousClose = { hidden: closeButton.hidden, tabIndex: closeButton.tabIndex, ariaHidden: closeButton.getAttribute('aria-hidden') || 'false' };
      }
      open = true;
      content.hidden = false;
      menu.classList.remove('is-shop-closing');
      resize();
      menu.classList.add('is-shop-open');
      if (opening) flowHeader(before, true);
      closeButton.hidden = false;
      closeButton.tabIndex = 0;
      closeButton.setAttribute('aria-hidden', 'false');
      closeButton.setAttribute('aria-label', 'メニューに戻る');
      activationFrame = requestAnimationFrame(() => {
        content.classList.add('is-active');
        revealIllustration(kind);
      });
    });
  });

  content.querySelectorAll('[data-shop-modal-close]').forEach(button => button.addEventListener('click', () => close()));
  content.querySelector('[data-shop-modal-link]')?.addEventListener('click', () => close(false));
  menu.addEventListener('fermenta:shop-back', () => close());
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && open) { event.preventDefault(); close(); }
  });
  document.addEventListener('click', event => {
    if (open && !menu.contains(event.target)) close(false);
  });
  window.addEventListener('resize', resize, { passive: true });
  document.addEventListener('fermenta:cart-updated', resize);
})();
